/* unplugin-vue-components disabled */import { render } from "./QuickOrderModal.vue?vue&type=template&id=804876f0"
import script from "./QuickOrderModal.vue?vue&type=script&lang=js"
export * from "./QuickOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__